import Quest from "./Quest";

export default class QuestFetch extends Quest {
    /**
     * @param {string} id
     * @param {string} owner
     */
    constructor(id, owner) {
        super(id, owner);

        this._item = null;
    }

    /**
     * @param {object} metadata
     */
    init(metadata) {
        super.init(metadata);

        this._item = metadata.item;
    }

    /**
     * @returns {string}
     */
    get item() {
        return this._item;
    }
}